import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_account_user",
  "aria-expanded": "true",
  "aria-controls": "kt_account_user"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Tambah Media")
  ])
], -1)
const _hoisted_3 = {
  id: "kt_media",
  class: "collapse show"
}
const _hoisted_4 = { class: "card-body border-top p-9" }
const _hoisted_5 = { class: "row mb-6" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 col-form-label required fw-bold fs-6" }, "Source", -1)
const _hoisted_7 = { class: "col-5 fv-row" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Pilih Source", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("option", { value: "news" }, "Media Online", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("option", { value: "media_cetak" }, "Media Cetak", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("option", { value: "media_tv" }, "Media TV", -1)
const _hoisted_12 = { class: "fv-plugins-message-container" }
const _hoisted_13 = { class: "fv-help-block" }
const _hoisted_14 = { class: "row mb-6" }
const _hoisted_15 = { class: "col-2 col-form-label required fw-bold fs-6" }
const _hoisted_16 = {
  key: 0,
  class: "col-5 fv-row"
}
const _hoisted_17 = { class: "fv-plugins-message-container" }
const _hoisted_18 = { class: "fv-help-block" }
const _hoisted_19 = {
  key: 1,
  class: "col-5 fv-row"
}
const _hoisted_20 = { class: "fv-plugins-message-container" }
const _hoisted_21 = { class: "fv-help-block" }
const _hoisted_22 = {
  key: 0,
  class: "row mb-6"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 col-form-label required fw-bold fs-6" }, "Nama Stasiun TV", -1)
const _hoisted_24 = { class: "col-5 fv-row" }
const _hoisted_25 = { class: "fv-plugins-message-container" }
const _hoisted_26 = { class: "fv-help-block" }
const _hoisted_27 = { class: "row mb-6" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 col-form-label required fw-bold fs-6" }, "Cakupan", -1)
const _hoisted_29 = { class: "col-5 fv-row" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Pilih Cakupan", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("option", { value: "lokal" }, "Lokal", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("option", { value: "nasional" }, "Nasional", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("option", { value: "internasional" }, "Internasional", -1)
const _hoisted_34 = { class: "fv-plugins-message-container" }
const _hoisted_35 = { class: "fv-help-block" }
const _hoisted_36 = {
  key: 1,
  class: "row mb-6"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 col-form-label required fw-bold fs-6" }, "Provinsi", -1)
const _hoisted_38 = { class: "col-5 fv-row" }
const _hoisted_39 = { class: "fv-plugins-message-container" }
const _hoisted_40 = { class: "fv-help-block" }
const _hoisted_41 = { class: "row mb-6" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 col-form-label required fw-bold fs-6" }, "Tipe", -1)
const _hoisted_43 = { class: "col-5 fv-row" }
const _hoisted_44 = /*#__PURE__*/_createTextVNode("> ")
const _hoisted_45 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Pilih Tipe", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("option", { value: "online" }, "Online", -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("option", { value: "offline" }, "Offline", -1)
const _hoisted_48 = { class: "fv-plugins-message-container" }
const _hoisted_49 = { class: "fv-help-block" }
const _hoisted_50 = {
  key: 2,
  class: "row mb-6"
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 col-form-label required fw-bold fs-6" }, "Hitam Putih", -1)
const _hoisted_52 = { class: "col-10 fv-row" }
const _hoisted_53 = { class: "row" }
const _hoisted_54 = { class: "col-3" }
const _hoisted_55 = { class: "fv-plugins-message-container" }
const _hoisted_56 = { class: "fv-help-block" }
const _hoisted_57 = { class: "col-3" }
const _hoisted_58 = { class: "fv-plugins-message-container" }
const _hoisted_59 = { class: "fv-help-block" }
const _hoisted_60 = {
  key: 3,
  class: "row mb-6"
}
const _hoisted_61 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 col-form-label required fw-bold fs-6" }, "Berwarna", -1)
const _hoisted_62 = { class: "col-10 fv-row" }
const _hoisted_63 = { class: "row" }
const _hoisted_64 = { class: "col-3" }
const _hoisted_65 = { class: "fv-plugins-message-container" }
const _hoisted_66 = { class: "fv-help-block" }
const _hoisted_67 = { class: "col-3" }
const _hoisted_68 = { class: "fv-plugins-message-container" }
const _hoisted_69 = { class: "fv-help-block" }
const _hoisted_70 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("button", {
  type: "reset",
  class: "btn btn-white btn-active-light-primary me-2"
}, " Reset ", -1)
const _hoisted_72 = {
  type: "submit",
  id: "kt_user_submit",
  ref: "submitButton1",
  class: "btn btn-primary"
}
const _hoisted_73 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Save", -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Harap Tunggu... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_75 = [
  _hoisted_73,
  _hoisted_74
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Form, {
        id: "kt_form_media",
        class: "form",
        novalidate: "novalidate",
        onSubmit: _cache[11] || (_cache[11] = ($event: any) => (_ctx.saveChanges1())),
        "validation-schema": _ctx.FormMediaValidator
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_Field, {
                  name: "source",
                  as: "select",
                  class: "form-select",
                  "aria-label": "Select example",
                  modelValue: _ctx.FormMedia.source,
                  "onUpdate:modelValue": [
                    _cache[0] || (_cache[0] = ($event: any) => ((_ctx.FormMedia.source) = $event)),
                    _ctx.mediaNameFormatter
                  ]
                }, {
                  default: _withCtx(() => [
                    _hoisted_8,
                    _hoisted_9,
                    _hoisted_10,
                    _hoisted_11
                  ]),
                  _: 1
                }, 8, ["modelValue", "onUpdate:modelValue"]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_ErrorMessage, { name: "source" })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.FormMedia.source == "media_tv" ? "Nama Program" : "Nama Media"), 1),
              (_ctx.FormMedia.source == 'media_tv')
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "program",
                      class: "form-control form-control-lg",
                      placeholder: "Nama Program",
                      modelValue: _ctx.FormMedia.nama,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.FormMedia.nama) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_ErrorMessage, { name: "program" })
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "media",
                      class: "form-control form-control-lg",
                      placeholder: "Nama Media",
                      maxlength: "50",
                      modelValue: _ctx.FormMedia.nama,
                      "onUpdate:modelValue": [
                        _cache[2] || (_cache[2] = ($event: any) => ((_ctx.FormMedia.nama) = $event)),
                        _ctx.mediaNameFormatter
                      ]
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_ErrorMessage, { name: "media" })
                      ])
                    ])
                  ]))
            ]),
            (_ctx.FormMedia.source == 'media_tv')
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "stasiun",
                      class: "form-control form-control-lg",
                      placeholder: "Nama Stasiun TV",
                      modelValue: _ctx.FormMedia.stasiun,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.FormMedia.stasiun) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_ErrorMessage, { name: "stasiun" })
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("div", _hoisted_29, [
                _createVNode(_component_Field, {
                  name: "cakupan",
                  as: "select",
                  class: "form-select",
                  "aria-label": "Select example",
                  modelValue: _ctx.FormMedia.cakupan,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.FormMedia.cakupan) = $event)),
                  onChange: _ctx.changeCakupan
                }, {
                  default: _withCtx(() => [
                    _hoisted_30,
                    _hoisted_31,
                    _hoisted_32,
                    _hoisted_33
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _createVNode(_component_ErrorMessage, { name: "cakupan" })
                  ])
                ])
              ])
            ]),
            (_ctx.FormMedia.cakupan == 'nasional')
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _hoisted_37,
                  _createElementVNode("div", _hoisted_38, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "provinsi",
                      class: "form-control form-control-lg",
                      placeholder: "provinsi",
                      modelValue: _ctx.FormMedia.provinsi,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.FormMedia.provinsi) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, [
                        _createVNode(_component_ErrorMessage, { name: "provinsi" })
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_41, [
              _hoisted_42,
              _createElementVNode("div", _hoisted_43, [
                _createVNode(_component_Field, {
                  name: "tipe",
                  as: "select",
                  class: "form-select",
                  "aria-label": "Select example",
                  modelValue: _ctx.FormMedia.tipe,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.FormMedia.tipe) = $event))
                }, {
                  default: _withCtx(() => [
                    _hoisted_44,
                    _hoisted_45,
                    _hoisted_46,
                    _hoisted_47
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _createVNode(_component_ErrorMessage, { name: "tipe" })
                  ])
                ])
              ])
            ]),
            (_ctx.FormMedia.source == 'media_cetak')
              ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                  _hoisted_51,
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, [
                      _createElementVNode("div", _hoisted_54, [
                        _createVNode(_component_Field, {
                          type: "text",
                          name: "lebar_bw",
                          autocomplete: "off",
                          class: "form-control form-control-lg",
                          placeholder: "Lebar",
                          onKeypress: _ctx.isNumber,
                          modelValue: _ctx.FormMedia.bw.lebar,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.FormMedia.bw.lebar) = $event))
                        }, null, 8, ["onKeypress", "modelValue"]),
                        _createElementVNode("div", _hoisted_55, [
                          _createElementVNode("div", _hoisted_56, [
                            _createVNode(_component_ErrorMessage, { name: "lebar_bw" })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_57, [
                        _createVNode(_component_Field, {
                          type: "text",
                          name: "rate_bw",
                          id: "rateBw",
                          class: "form-control form-control-lg",
                          placeholder: "Rate AD",
                          autocomplete: "off",
                          onKeypress: _ctx.isNumber,
                          modelValue: _ctx.FormMedia.bw.rate,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.FormMedia.bw.rate) = $event))
                        }, null, 8, ["onKeypress", "modelValue"]),
                        _createElementVNode("div", _hoisted_58, [
                          _createElementVNode("div", _hoisted_59, [
                            _createVNode(_component_ErrorMessage, { name: "rate_bw" })
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.FormMedia.source == 'media_cetak')
              ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                  _hoisted_61,
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("div", _hoisted_64, [
                        _createVNode(_component_Field, {
                          type: "text",
                          name: "lebar_fc",
                          class: "form-control form-control-lg",
                          placeholder: "Lebar",
                          onKeypress: _ctx.isNumber,
                          modelValue: _ctx.FormMedia.fc.lebar,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.FormMedia.fc.lebar) = $event))
                        }, null, 8, ["onKeypress", "modelValue"]),
                        _createElementVNode("div", _hoisted_65, [
                          _createElementVNode("div", _hoisted_66, [
                            _createVNode(_component_ErrorMessage, { name: "lebar_fc" })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_67, [
                        _createVNode(_component_Field, {
                          type: "text",
                          name: "rate_fc",
                          id: "rateFC",
                          class: "form-control form-control-lg",
                          placeholder: "Rate AD",
                          autocomplete: "off",
                          onKeypress: _ctx.isNumber,
                          modelValue: _ctx.FormMedia.fc.rate,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.FormMedia.fc.rate) = $event))
                        }, null, 8, ["onKeypress", "modelValue"]),
                        _createElementVNode("div", _hoisted_68, [
                          _createElementVNode("div", _hoisted_69, [
                            _createVNode(_component_ErrorMessage, { name: "rate_fc" })
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_70, [
            _hoisted_71,
            _createElementVNode("button", _hoisted_72, _hoisted_75, 512)
          ])
        ]),
        _: 1
      }, 8, ["validation-schema"])
    ])
  ]))
}